module.exports = __webpack_public_path__ + "img/logo.5f6019a4.svg";